import moment from 'moment'
import { Popover } from 'antd'
import { ApartmentOutlined } from '@ant-design/icons'

import { IListeners } from './types'
import { ComponentsHeader } from '@primitive/sectionHeadings'

import { useDeviceType } from '@hooks/useDeviceType'

import imgEmty from '@img/empty.svg'
import imgAccessDenied from '@img/access_denied.svg'
import { IconDownload, IconFiles, IconListeners } from '@img/icons'
import { Empty, Flex, Pagination, Loader, Table, ToolTip, Button, Badge } from '@ui/index'

import css from './ui.module.scss'


/** Слушатели */
export const Listeners = ({
    isLoading, txtSearch, isAccessDenied,
    currentPageNumber, totalCount, pageSize, listenersList, 
    loadPrimaryData, setTxtSearch, handleOpenCardListener,
    handleOpenListenerJourney, handleDownloadFiles, handleOpenModalPreview
}: IListeners) => {
    const deviceType = useDeviceType()
    
    const footer = (
        <div className={css['footer']}>
            <Flex gap="4px" flexDirection="row">
                <ToolTip title='Общее количество' placement="topLeft">
                    <p className={css['stat_all']}>{totalCount}</p>
                </ToolTip>
            </Flex>

            <Pagination
                totalCount={totalCount}
                pageSize={pageSize}
                currentPage={currentPageNumber.value}
                onChange={(e) => currentPageNumber.setValue(e)}
            />
        </div>
    )

    return <div className={css['container']}>

        <ComponentsHeader
            isAccessDenied={isAccessDenied.value}
            headerIcon={<IconListeners width="20px" height="20px" />}
            headerTitle="Слушатели"
            txtSearch={txtSearch}
            txtSearchTooltip={<>Поиск по:<br />✓ Фамилии<br />✓ Имени<br />✓ Отчеству<br />✓ Телефону<br />✓ Email<br />✓ СНИЛС<br />✓ Паспорту<br />✓ Адресу<br />✓ Диплому</>}
            txtSearchOnChange={(e) => setTxtSearch(e.target.value)}
            txtSearchClearOnClick={() => setTxtSearch('')}
            btnUpdateOnClick={() => loadPrimaryData(txtSearch)}
            btnCreateOnClick={() => handleOpenCardListener(true, "new")}
        />


        <Table.Container footer={footer} footerPlacement='page'>
            <Loader isOpen={isLoading} backdrop title="Загрузка..." />
            <Table.Header paddingLeft='18px' paddingRight='98px' classNameContent={css['table_grid_columns_header']}>
                <p style={{textAlign: 'center'}}>№<br/>анкеты</p>
                <p>ФИО слушателя<br />Телефон / СНИЛС слушателя</p>
                <p>Адрес прописки<br />Комментарий</p>
                <p style={{textAlign: 'center'}}>Дата создания</p>
            </Table.Header>

            <Table.Content>
                {listenersList.length === 0
                    ? <Empty image={isAccessDenied.value ? imgAccessDenied : imgEmty} title={isAccessDenied.value ? 'Доступ запрещён' : 'Данные отсутствуют'} />
                    : listenersList.map((item) => (
                        <Table.Row key={item.listenerID} className={css['table_grid_columns_row']} onClick={() => handleOpenCardListener(true, "edit", item.listenerID)}>
                            <p style={{textAlign: 'center'}}>{item.listenerID}</p>

                            <div style={{textWrap: 'nowrap', overflow: 'hidden'}}>
                                <p>{item.lastName} {item.firstName} {item.secondName}</p>
                                <Flex gap='5px' flexDirection='row'><p style={{ opacity: '.7' }}>
                                    {item.phoneNumber}</p> / <p style={{ opacity: '.7', color: `${item.snils.length > 14 ? 'red' : 'inherit'}` }}>{item.snils}</p>
                                </Flex>
                            </div>

                            <div style={{textWrap: 'nowrap', overflow: 'hidden'}}>
                                <p>{item.registration || '----'}</p>
                                <p style={{ opacity: '.7' }}>{item.comment || '----'}</p>
                            </div>

                            <div className={css['hidden_1000']} style={{textAlign: 'center'}}>
                                <p>{moment(item.dateCreate).format('DD.MM.YYYY')}</p>
                                <p>{moment(item.dateCreate).format('HH:mm:ss')}</p>
                            </div>

                            <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                <ToolTip title='Полный цикл слушателя' placement="bottom">
                                    <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'}
                                        onClick={(e) => {
                                            handleOpenListenerJourney(item.listenerID)
                                            e.stopPropagation()
                                        }}
                                    >
                                        <ApartmentOutlined aria-hidden='true' />
                                        <span className={css['visually_hidden']}>Открыть полный цикл слушателя</span>
                                    </Button>
                                </ToolTip>

                                <div style={{ position: 'relative' }}>
                                    <Popover content={
                                        item.files.length === 0
                                            ? <Empty image={imgEmty} size='100px' />
                                            : item.files.map((item, index) => (
                                                <Table.Row key={item.listenerFileID} className={css['table_grid_columns_row_file']} onClick={(e) => { handleOpenModalPreview(true, item.filePath, item.fileName); e.stopPropagation() }}>
                                                    <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                        <p>{item.fileName}</p>
                                                        <p style={{ opacity: '.8' }}>Размер файла: {item.fileSize}</p>
                                                    </div>

                                                    <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                                        <ToolTip title='Скачать' placement="bottomRight">
                                                            <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'}
                                                                onClick={(e) => {
                                                                    handleDownloadFiles(item.filePath, item.fileName)
                                                                    e.stopPropagation()
                                                                }}
                                                            ><IconDownload width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                                        </ToolTip>
                                                    </Flex>
                                                </Table.Row>
                                            ))
                                    } trigger="click" placement="bottomRight" styles={{ root: { width: '300px' } }}>
                                        <div
                                            onClick={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.stopPropagation()}
                                        >
                                            <Button id='tooltipBtnMailings' variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'}>
                                                <IconFiles width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} />
                                            </Button>
                                        </div>
                                    </Popover>

                                    <Badge bottom='-4px' right='-4px' background={item.countFiles === 0 ? 'red' : 'green'}>{item.countFiles}</Badge>
                                </div>
                            </Flex>
                        </Table.Row>
                    ))
                }
            </Table.Content>
        </Table.Container>

                
    </div>
}
